// Vidéo locale : confection de burger (remplacez public/videos/promo.mp4 si besoin)
export const PROMO_VIDEO = {
  mp4Url: `${process.env.PUBLIC_URL}/videos/promo.mp4`,
};
